// 德语（德国）
export default {
  company: {
    deviceList: 'Geräteliste',
    name: 'TIME PHOTO',
    desc: 'Genieße die wunderbare Zeit!',
    companyName: 'Händlername',
    companyInfo: 'Händlerinformationen',
    linkMan: 'Ansprechpartner',
    contactInfo: 'Kontaktinformationen',
    cooperationWay: 'Kooperationsmodell',
    jointOperation: 'Gemeinschaftsbetrieb',
    selfOperated: 'Eigenbetrieb',
    agent: 'Agentur',
    businessStatus: 'Geschäftsstatus',
    operating: 'In Betrieb',
    stopped: 'Geschlossen',
    hasBackend: 'Backend aktiviert',
    backendAccount: 'Backend-Konto',
    backendPassword: 'Backend-Passwort',
    deviceCount: 'Anzahl Maschinen',
    orderData: 'Bestelldaten',
    companyRatio: 'Händleranteil (%)',
    operatorRatio: 'Betreiberanteil (%)',
    companyDesc: 'Händlerbeschreibung',
    companyAddress: 'Händleradresse',
    openAggregatedPay: 'Aggregierte Zahlung aktiviert',
    thirdPayWay: 'Drittanbieter-Zahlungsmethode',
    merchantId: 'Händler-ID',
    merchantType: 'Händlertyp',
    merchantAppid: 'Händler-Appid',
    wechatRedirectUrl: 'WeChat-Payment-Weiterleitungs-URL',
    payNotifyUrl: 'Zahlungs-Callback-URL',
    refundNotifyUrl: 'Erstattungs-Callback-URL',
    sqbMerchantCode: 'Händlercode (Shouqianba)',
    sqbDeveloperKey: 'Shouqianba-Entwicklerschlüssel',
    storeActiveCode: 'Store-Aktivierungscode',
    frontendCallbackUrl: 'Frontend-Callback-URL',
    merchantSecret: 'Händler-Secret',
    unit: 'Stück',
    merchantLevel: 'Händlerstufe',
    level2Merchant: 'Stufe-2-Händler',
    level3Merchant: 'Stufe-3-Händler',
    aggregatedPayMerchant: 'Aggregierter Zahlungshändler',
    backendOpen: 'Backend offen',
    forwardIncomingPrefix: 'Huilaimi Eingang_',
    qrCodeGenerateFailed: 'QR-Code konnte nicht generiert werden, bitte erneut versuchen',
    invalidWebUrl: 'Ungültige Web-URL erhalten, bitte Administrator kontaktieren',
    noValidWebUrl: 'Keine gültige Web-URL erhalten',
    fetchDataFailed: 'Daten konnten nicht abgerufen werden, bitte erneut versuchen',
    browserNotSupportDownload: 'Ihr Browser unterstützt keinen automatischen Download, bitte rechtsklicken um das Bild zu speichern',
    downloadImageFailed: 'Bild konnte nicht heruntergeladen werden, bitte erneut versuchen',
    httpError: 'HTTP-Fehler, Statuscode: {status}',
    copyCompanyName: 'Händlername kopieren',
    copySuccess: 'Erfolgreich kopiert',
    copyFail: 'Kopieren fehlgeschlagen'
  },
  income: {
    totalIncome: 'Gesamtbestellbetrag',
    platformIncome: 'Plattformanteil',
    companyIncome: 'Einnahmen des Händlersystems',
    subMerchantIncome: 'Anteil des Subhändlers',
    parentIncome: 'Einbehalt des übergeordneten Händlers',
    orderCount: 'Bestellanzahl',
    subMerchantIncomeDetail: 'Einnahmendetails der Subhändler',
    subRatioText: 'Subhändler-Einbehalt',
    subJustRatioText: 'Übergeordnete Provision',
    splitRatio: 'Aufteilungsverhältnis',
    deviceCount: 'Geräteanzahl',
    deviceCode: 'Gerätecode',
    deviceName: 'Gerätename'
  },
  login: {
    username: 'Benutzername',
    password: 'Passwort',
    login: 'Anmelden',
    inputUsername: 'Bitte geben Sie den Benutzernamen ein',
    inputPassword: 'Bitte geben Sie das Passwort ein'
  },
  employee: {
    inputAccount: 'Bitte Konto eingeben',
    inputName: 'Bitte Namen eingeben',
    inputMobile: 'Bitte Mobilnummer eingeben',
    selectRole: 'Bitte Rolle auswählen',
    allRoles: 'Alle Rollen',
    allStatus: 'Alle Status',
    collapse: 'Einklappen',
    expand: 'Ausklappen',
    employeeCount: 'Mitarbeiteranzahl: ',
    addEmployee: '+ Mitarbeiter hinzufügen',
    account: 'Konto',
    name: 'Name',
    gender: 'Geschlecht',
    role: 'Rolle',
    company: 'Zugehöriges Unternehmen',
    creator: 'Hinzugefügt von',
    createTime: 'Hinzugefügt am',
    devicePermission: 'Geräteberechtigung',
    deviceCountUnit: '{count} Gerät(e)',
    viewAllDevices: 'Alle Geräte anzeigen',
    disableAccount: 'Deaktivieren',
    resetPassword: 'Passwort zurücksetzen',
    assignDevices: 'Geräte zuweisen',
    tip: 'Hinweis',
    deleteConfirm: 'Nach dem Löschen kann sich das Konto nicht mehr anmelden. Löschen bestätigen?',
    employeeName: 'Mitarbeitername: ',
    usernameLabel: 'Benutzername: ',
    currentPermission: 'Aktuelle Berechtigung: ',
    assignedDevices: '{count} Gerät(e) zugewiesen',
    selectDevice: 'Geräte auswählen: ',
    selectDevicePlaceholder: 'Bitte Geräte auswählen',
    deviceHint: 'Kein Gerät auswählen bedeutet, dass der Mitarbeiter alle Geräte des Unternehmens sehen kann',
    selectAtLeastOneDevice: 'Bitte mindestens 1 Gerät auswählen',
    assignSuccess: 'Geräte erfolgreich zugewiesen',
    assignFailed: 'Zuweisung fehlgeschlagen',
    loadDeviceInfoFailed: 'Geräteinformationen konnten nicht geladen werden',
    loadDeviceListFailed: 'Geräteliste konnte nicht geladen werden',
    disableConfirmTitle: 'Dieses Mitarbeiterkonto wirklich deaktivieren?',
    disableConfirmContent: 'Nach der Deaktivierung kann sich der Mitarbeiter nicht mehr anmelden',
    disableSuccess: 'Erfolgreich deaktiviert',
    enableConfirmTitle: 'Dieses Mitarbeiterkonto wirklich aktivieren?',
    enableConfirmContent: 'Nach der Aktivierung kann sich der Mitarbeiter anmelden',
    enableSuccess: 'Erfolgreich aktiviert',
    resetPwdConfirmTitle: 'Passwort dieses Mitarbeiters wirklich zurücksetzen?',
    resetPwdConfirmContent: 'Nach dem Zurücksetzen wird das Passwort auf das Standardpasswort (JTphoto0515) zurückgesetzt',
    resetPwdSuccess: 'Passwort erfolgreich zurückgesetzt',
    addSuccess: 'Mitarbeiter erfolgreich hinzugefügt',
    updateSuccess: 'Mitarbeiter erfolgreich geändert',
    addTitle: 'Mitarbeiter hinzufügen',
    editTitle: 'Mitarbeiter bearbeiten',
    accountLabel: 'Konto:',
    nameLabel: 'Name:',
    passwordLabel: 'Passwort:',
    defaultPwdTip: 'Leer lassen, um das Standardpasswort JTphoto0515 zu verwenden',
    defaultPwdPlaceholder: 'Leer lassen für Standardpasswort',
    emailLabel: 'E-Mail:',
    emailInvalid: 'Bitte eine gültige E-Mail eingeben',
    maxLength50: 'Länge darf 50 Zeichen nicht überschreiten',
    mobileLabel: 'Mobil:',
    mobileInvalid: 'Bitte eine gültige Mobilnummer eingeben',
    roleSetting: 'Rolle:',
    statusSetting: 'Status:',
    selectStatus: 'Bitte Status auswählen',
    genderSetting: 'Geschlecht:',
    selectGender: 'Bitte Geschlecht auswählen',
    deptSetting: 'Abteilung:',
    remarkLabel: 'Anmerkung:',
    remarkPlaceholder: 'Bitte Anmerkung eingeben',
    submit: 'Absenden',
    save: 'Speichern',
    usernameRequired: 'Benutzername darf nicht leer sein',
    usernameMax20: 'Benutzername darf 20 Zeichen nicht überschreiten',
    usernameMin4: 'Benutzername muss mindestens 4 Zeichen haben',
    usernameExists: 'Dieser Benutzername existiert bereits',
    mobileRequired: 'Mobilnummer darf nicht leer sein!',
    nameRequired: 'Name darf nicht leer sein!',
    roleRequired: 'Rolle darf nicht leer sein!'
  },
  homepage: {
    totalIP: 'Gesamt-IP',
    todayfc: 'Heutige Einnahmen',
    weekQOQ: 'Wochenvergleich',
    dayQOQ: 'Tagesvergleich',
    todayCompanyIncome: 'Händlereinnahmen heute',
    todayPlatformIncome: 'Plattform-Einnahmen heute',
    todayFlow: 'Kundenfluss heute',
    todayOrder: 'Bestellungen heute',
    todayRefundOrder: 'Rückerstattungen heute',
    machineOnlineCount: 'Maschinen online',
    machineOfflineCount: 'Maschinen offline',
    totalPlatformIncome: 'Gesamte Plattform-Einnahmen',
    totalOperatorIncome: 'Gesamte Betreiber-Provision',
    totalCompanyIncome: 'Gesamte Händlereinnahmen',
    totalFlow: 'Gesamter Kundenfluss',
    totalOrder: 'Gesamtbestellungen',
    totalRefundOrder: 'Gesamte Rückerstattungen',
    usage: 'Nutzung',
    incomeAmount: 'Einnahmebetrag',
    flow: 'Fluss',
    orderCount: 'Bestellanzahl',
    todayIncome: 'Heutige Einnahmen',
    lastLoginTime: 'Letzte Anmeldung',
    canWithdrawalIncome: 'Auszahlbare Einnahmen',
    goodMorning: 'Guten Morgen',
    goodForenoon: 'Guten Vormittag',
    goodNoon: 'Guten Mittag',
    goodAfternoon: 'Guten Nachmittag',
    goodEvening: 'Guten Abend',
    welcome1: 'Nehmen Sie sich eine Pause mit Kaffee ☕',
    welcome2: 'Möchten Sie LOL mit Freunden spielen?',
    welcome3: 'Möchten Sie Honor of Kings mit Freunden spielen?',
    welcome4: 'Sie sehen nach ein paar Tagen noch besser aus 😍',
    welcome5: 'Wie viele Bugs haben Sie heute geschrieben 🐞?',
    welcome6: 'Haben Sie heute in der Gruppe gechatet?',
    welcome7: 'Was Leckeres haben Sie heute gegessen?',
    welcome8: 'Haben Sie heute gelächelt 😊?',
    welcome9: 'Haben Sie heute anderen bei der Lösung von Problemen geholfen?',
    welcome10: 'Was werden Sie essen?',
    welcome11: 'Dieses Wochenende ins Kino gehen?',
    dateRange: '{start}~{end}',
    withdraw: 'Auszahlung',
    avatarAlt: 'Avatar',
    noDept: 'Keine Abteilung',
    noRole: 'Keine Rolle',
    firstVisit: 'Erster Besuch',
    todayIp: 'Heutige IP',
    todayVisit: 'Heutige Besuche',
    totalVisit: 'Gesamtbesuche',
    lowPaperTitle: 'Warnung: Fotopapier fast leer',
    lowPaperTip: 'Die folgenden Geräte haben weniger als {count} Blatt Fotopapier übrig. Bitte füllen Sie das Papier rechtzeitig nach, um die normale Nutzung nicht zu beeinträchtigen!',
    lowPaperDeviceName: 'Gerätename',
    lowPaperDeviceCode: 'Gerätecode',
    lowPaperCount: 'Papiermenge',
    lowPaperClose: 'Schließen'
  },
  device: {
    companyManage: 'Händlerverwaltung',
    deviceManage: 'Geräteverwaltung',
    totalDevices: 'Gesamtmaschinen',
    all: 'Alle',
    online: 'Online',
    offline: 'Offline',
    updating: 'Aktualisierung',
    versionUpdate: 'Versionsaktualisierung',
    export: 'Exportieren',
    batchUpdate: 'Batch-Aktualisierung',
    unbind: 'Entkoppeln',
    bind: 'Koppeln',
    companyName: 'Händlername',
    deviceCode: 'Gerätecode',
    appVersion: 'App-Version',
    sn: 'Seriennummer',
    uiName: 'UI-Name',
    uiGroupName: 'UI-Gruppe',
    photoTime: 'Fotozeit',
    intervalTime: 'Intervallzeit',
    pagerNum: 'Seitenzahl',
    goodsNum: 'Produktanzahl',
    filterNum: 'Filteranzahl',
    address: 'Maschinenadresse',
    orderCount: 'Bestellanzahl',
    operation: 'Operation',
    command: 'Befehl erfolgreich gesendet',
    reset: 'Zurücksetzen',
    restartApp: 'App neu starten',
    showMenu: 'Menü anzeigen',
    hideMenu: 'Menü ausblenden',
    reportLog: 'Protokoll melden',
    isSupperCoins: 'Münzunterstützung',
    unbinded: 'Entkoppelt',
    binded: 'Gekoppelt',
    bindStatus: 'Bindungsstatus',
    lastestOnlineTime: 'Letzte Online-Zeit',
    macAddress: 'MAC-Adresse',
    resolution: 'Auflösung',
    deviceSN: 'Geräte-SN',
    deviceVersion: 'Geräteversion',
    deviceKey: 'Geräteschlüssel',
    deviceIMEI: 'Geräte-IMEI',
    activationCode: 'Aktivierungscode',
    leyaoyaoCode: 'Leyaoyao-Code',
    electronicPhoto: 'Elektronisches Foto',
    scanDownload: 'Scannen zum Herunterladen',
    sendFriend: 'An Freund senden',
    templateImage: 'Vorlagenbild',
    working: 'Arbeitet',
    workStatus: 'Arbeitsstatus',
    thumbnail: 'Miniaturansicht',
    remoteCode: 'Ferncode',
    belongCategory: 'Kategorie',
    allMerchants: 'Alle Händler',
    assign: 'Zuweisen',
    viewOrders: 'Bestellungen anzeigen',
    selectBindMerchant: 'Bitte wählen Sie den zu bindenden Händler',
    pendingVendorActive: 'Shouqianba-Aktivierung ausstehend',
    vendorActivationCode: 'Shouqianba-Aktivierungscode',
    vendorActivationCodePlaceholder: 'Bitte Shouqianba-Aktivierungscode eingeben',
    vendorActivationCodeRequired: 'Bitte geben Sie den Shouqianba-Aktivierungscode ein',
    merchantName: 'Händlername',
    selectMerchantName: 'Bitte wählen Sie den Händlernamen',
    assignDeviceToSub: 'Gerät einem Unterhändler zuweisen',
    deviceLabel: 'Gerät: ',
    targetMerchant: 'Zielhändler',
    selectSubMerchant: 'Bitte wählen Sie einen Unterhändler',
    noSubMerchant: 'Kein Unterhändler verfügbar, bitte erstellen Sie zuerst einen Level-3-Händler',
    selectTargetMerchant: 'Bitte wählen Sie einen Zielhändler',
    assignSuccess: 'Gerät erfolgreich zugewiesen',
    assignFailed: 'Gerätezuweisung fehlgeschlagen',
    selectDeviceToUpdate: 'Bitte wählen Sie zu aktualisierende Geräte! Mindestens eines',
    setupSuccess: 'Geräteeinrichtung erfolgreich',
    updateUI: 'UI aktualisieren',
    updateApp: 'APP aktualisieren',
    updateConfig: 'Konfiguration aktualisieren',
    shellExec: 'Shell-Befehlsausführung',
    shellCommand: 'Shell-Befehl',
    shellCommandPlaceholder: 'Geben Sie den auszuführenden Shell-Befehl ein, z.B.: ls -la /tmp',
    sendShellCommand: 'Shell-Befehl senden',
    dangerousConfirmTip: 'Gefährliche Befehle erfordern eine Bestätigung',
    notifiedUpdateUI: 'Gerät benachrichtigt, UI zu aktualisieren',
    notifiedUpdateApp: 'Gerät benachrichtigt, APP zu aktualisieren',
    notifiedUpdateConfig: 'Gerät benachrichtigt, Konfiguration zu aktualisieren',
    inputShellCommand: 'Bitte geben Sie einen Shell-Befehl ein',
    dangerousWarningTitle: '⚠️ Warnung vor gefährlicher Operation',
    dangerousWarningContent: 'Sie führen einen gefährlichen Befehl aus, der Geräteanomalien verursachen kann! Fortfahren?',
    confirmExecute: 'Bestätigen',
    commandSent: 'Befehl gesendet, bitte warten Sie, bis das Gerät ihn ausführt',
    sendFailed: 'Senden fehlgeschlagen',
    networkError: 'Netzwerkfehler, bitte versuchen Sie es später erneut',
    confirmUnbind: 'Nach dem Entbinden wird das Gerät vom Händler getrennt. Möchten Sie dieses Gerät wirklich entbinden?',
    copyCompanyName: 'Händlername kopieren',
    copyDeviceCode: 'Gerätecode kopieren',
    copyActiveCode: 'Aktivierungscode kopieren',
    copySuccess: 'Erfolgreich kopiert',
    copyFail: 'Kopieren fehlgeschlagen'
  },
  setting: {
    navbarColor: 'Navigationsleistenfarbe',
    themeColor: 'Themenfarbe',
    navbarPosition: 'Navigationsleistenposition',
    fixedTopRail: 'Obere Leiste fixieren',
    fixedSidebar: 'Seitenleiste fixieren',
    multiTabMode: 'Multi-Tab-Modus',
    languageSwitching: 'Sprache wechseln',
    userCenter: 'Benutzerzentrum',
    updatePassword: 'Passwort aktualisieren',
    customSystem: 'System anpassen',
    logout: 'Abmelden',
    updateCache: 'Cache aktualisieren',
    refreshCacheSuccess: 'Cache erfolgreich aktualisiert',
    refreshCacheFailed: 'Cache-Aktualisierung fehlgeschlagen'
  },
  common: {
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    saveSetting: 'Einstellungen speichern',
    languageChanged: 'Sprache erfolgreich geändert',
    timezoneChanged: 'Zeitzone erfolgreich geändert',
    search: 'Suchen',
    pleaseInputContent: 'Bitte geben Sie den Inhalt ein',
    export: 'Exportieren',
    default: 'Standard',
    item: 'Element',
    view: 'Anzeigen',
    setup: 'Einstellung',
    status: 'Status',
    showTotal: 'Zeige {start} ~ {end} Datensätze, insgesamt {total} Datensätze',
    yes: 'Ja',
    no: 'Nein',
    info: 'Information',
    sequenceNumber: 'Nr.',
    creationTime: 'Erstellungszeit',
    operation: 'Operation',
    defaultSort: 'Sortiernummer',
    type: 'Integriert',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    deleteSuccess: 'Erfolgreich gelöscht',
    editSuccess: 'Erfolgreich bearbeitet',
    updateSuccess: 'Erfolgreich aktualisiert',
    connectionError: 'Serververbindung abnormal, bitte versuchen Sie es später erneut!',
    reset: 'Zurücksetzen',
    allCategory: 'Alle Kategorien',
    query: 'Abfrage',
    add: 'Hinzufügen',
    loadError: 'Ladefehler',
    isDefault: 'Standard',
    setDefault: 'Als Standard festlegen',
    cancelDefault: 'Standard abbrechen',
    batchEdit: 'Batch-Bearbeitung',
    back: 'Zurück',
    uploadImg: 'Bild hochladen',
    uploadImgSuccess: 'Bild erfolgreich hochgeladen',
    uploadImgFailed: 'Upload fehlgeschlagen',
    uploadImgTips1: 'Nur JPG, JPEG, GIF, PNG Formate sind erlaubt',
    uploadImgTips2: 'Datei überschreitet 10M Limit, Upload nicht erlaubt',
    addSuccess: 'Erfolgreich hinzugefügt',
    all: 'Alle',
    batchAdd: 'Stapel hinzufügen',
    deleteError: 'Löschen fehlgeschlagen',
    deleteNoData: 'Bitte wählen Sie die zu löschenden Daten aus',
    disable: 'Deaktiviert',
    enable: 'Aktiviert',
    exportError: 'Export fehlgeschlagen!',
    exportExecl: 'Excel exportieren',
    exportSuccess: 'Export erfolgreich',
    noData: 'Keine Daten',
    operateError: 'Vorgang fehlgeschlagen, bitte erneut versuchen',
    prompt: 'Hinweis',
    searchError: 'Suche fehlgeschlagen',
    selectDataFirst: 'Bitte wählen Sie zuerst die zu exportierenden Sticker aus!',
    uploadError: 'Upload fehlgeschlagen',
    selectAll: 'Alle auswählen',
    totalRecords: 'Insgesamt {total} Datensätze',
    closeLeft: 'Links schließen',
    closeRight: 'Rechts schließen',
    closeOthers: 'Andere schließen'
  },
  template: {
    merchantManagement: 'Händler',
    uiManagement: 'UI',
    newConfig: 'Neuer Rahmen',
    editFrame: 'Rahmen bearbeiten',
    editConfig: 'Konfiguration bearbeiten',
    top: 'Oben',
    bottom: 'Unten',
    builtIn: 'Integriert',
    nonBuiltIn: 'Nicht integriert',
    uiConfigName: 'Name',
    background: 'Hintergrund',
    wechatOfficialAccount: 'QR-Code',
    title: 'Titel',
    banner: 'Banner',
    creationTime: 'Erstellungszeit',
    indicatorColor: 'Indikatorfarbe',
    type: 'Typ',
    appliedMachines: 'Angewendete Maschinen',
    freamName: 'Rahmenname',
    editSuccess: 'UI erfolgreich bearbeitet',
    tip: 'Hinweis',
    deletePrompt: 'Das Löschen dieser UI-Konfiguration verhindert, dass der Benutzer sie verwendet. Sind Sie sicher, dass Sie sie löschen möchten?',
    matchProduct: 'Produkt zuordnen',
    selectProduct: 'Bitte wählen Sie ein Produkt',
    templateFilePng: 'Vorlagendatei PNG',
    maxFileSize: 'Maximale Dateigröße ist 10M',
    addUploadImage: 'Hochgeladenes Bild hinzufügen',
    addHistoryImage: 'Historisches Bild auswählen',
    previewImage: 'Vorschau',
    cuttingImage: 'Schnittbild',
    groupPhotoFrame: 'Gruppenfoto-Rahmen',
    groupPhotoYes: 'Gruppenfoto',
    groupPhotoNo: 'Kein Gruppenfoto',
    groupPhotoLensSetting: 'Gruppenfoto-Objektivdetails einstellen',
    groupPhotoConfigured: 'Gruppenfoto konfiguriert',
    groupPhotoNotSet: 'Gruppenfoto nicht gesetzt',
    buttonNormal: 'Normaler Button',
    buttonPressed: 'Gedrückter Button',
    buttonNormalExample: 'Beispiel für normalen Button',
    buttonPressedExample: 'Beispiel für gedrückten Button',
    reuseTemplateFile: 'Vorlagendatei wiederverwenden',
    reuseNormalButton: 'Normalen Button wiederverwenden',
    reuseAllTemplateFiles: 'Alle Vorlagendateien wiederverwenden',
    productType: 'Produkttyp',
    stickerPreview: 'Sticker-Vorschau',
    stickerCode: 'Sticker-Code',
    stickerCategory: 'Kategorie',
    stickerType: 'Typ',
    stickerSize: 'Größe',
    stickerStatus: 'Status',
    stickerOperation: 'Operation',
    stickerName: 'Sticker-Name',
    addSticker: 'Sticker hinzufügen',
    editSticker: 'Sticker bearbeiten',
    StickerIndexNum: 'Sortiernummer',
    onlyImage: 'Es können nur JPG-, JPEG-, GIF- und PNG-Bilder hochgeladen werden',
    selectCategory: 'Bitte wählen Sie eine Kategorie',
    selectStatus: 'Bitte wählen Sie den Status',
    selectType: 'Bitte wählen Sie den Typ',
    stickerFileSize: 'Dateigröße',
    staticSticker: 'Statischer Sticker',
    gifSticker: 'GIF-Animation',
    videoSticker: 'Video-Sticker',
    frameGroup: 'Rahmengruppe'
  },
  sticker: {
    stickerPreview: 'Sticker-Bild',
    stickerCode: 'Sticker-Code',
    stickerCategory: 'Kategorie',
    stickerType: 'Typ',
    stickerSize: 'Größe',
    stickerStatus: 'Status',
    stickerOperation: 'Operation',
    stickerName: 'Sticker-Name',
    stickerImage: 'Sticker-Bild',
    stickerThumbnail: 'Miniaturansicht',
    stickerWidth: 'Breite (Pixel)',
    stickerHeight: 'Höhe (Pixel)',
    stickerDuration: 'Dateidauer (Sekunden)',
    stickerFileSize: 'Dateigröße',
    StickerIndexNum: 'Sortiernummer',
    stickerTags: 'Schlüsselwörter',
    stickerDescription: 'Beschreibung',
    statusTips: 'Bitte wählen Sie den Status',
    typeTips: 'Bitte wählen Sie den Typ',
    categoryTips: 'Bitte wählen Sie die Kategorie',
    editSticker: 'Sticker bearbeiten',
    imgPreview: 'Bildvorschau',
    codeCheckResultErr: '❌ Dieser Code existiert bereits, bitte ändern Sie ihn',
    codeCheckResultOk: '✅ Code verfügbar',
    inputCodeTips: 'Optional. Geräte unterscheiden Stikertypen anhand des Code-Suffixes (z. B. ST2D). Großbuchstaben, Ziffern und Unterstriche empfohlen',
    addSticker: 'Sticker hinzufügen',
    categoryIcon: 'Kategorie-Icon',
    categoryName: 'Kategoriename',
    categoryCode: 'Kategorie-Code',
    categoryIconPlaceholder: 'Bitte geben Sie die Icon-URL ein',
    addCategory: 'Kategorie hinzufügen',
    editCategory: 'Kategorie bearbeiten',
    groupNewAdd: 'Neue Gruppe',
    groupEdit: 'Gruppe bearbeiten',
    groupName: 'Gruppenname',
    groupCode: 'Gruppen-Code',
    groupIcon: 'Gruppen-Icon',
    hasSticker: 'Sticker-Anzahl',
    groupCodePlaceholder: 'Bitte geben Sie den Gruppen-Code ein (Großbuchstaben)',
    groupNamePlaceholder: 'Bitte geben Sie den Gruppennamen ein',
    groupDescriptionPHR: 'Bitte geben Sie die Gruppenbeschreibung ein',
    controllerSticker: 'Sticker verwalten',
    selectSticker: 'Sticker auswählen',
    addFailed: 'Hinzufügen fehlgeschlagen',
    addSuccess: 'Erfolgreich hinzugefügt',
    deleteFailed: 'Löschen fehlgeschlagen',
    deleteSuccess: 'Erfolgreich gelöscht',
    fileDurationDesc: 'Nur für Video/GIF, optional',
    fileDurationTips: 'Nur für Video-/GIF-Sticker erforderlich',
    fileSizeDesc: 'Wird nach dem Upload automatisch ausgefüllt',
    fileSizeExample: 'z.B.: 51200',
    heightExample: 'z.B.: 200',
    widthExample: 'z.B.: 200',
    selectAtLeastOne: 'Bitte wählen Sie mindestens einen Sticker aus',
    stickerCodeDesc: 'Global eindeutiger Identifikator, STICKER_XXX-Format empfohlen',
    stickerCodeTips: 'Bitte geben Sie den Sticker-Code ein (eindeutig)',
    stickerImageSize: 'Empfohlene Größe: 200x200 Pixel, unterstützt PNG-, JPG-Formate',
    thumbnail: 'Miniaturansicht',
    uploadStickerImage: 'Bitte laden Sie das Sticker-Bild hoch',
    confirmDeleteSticker: 'Sind Sie sicher, diesen Sticker zu löschen?',
    stickerSlected: 'Ausgewählte Sticker',
    inputStickerName: 'Bitte Sticker-Namen eingeben',
    inputStickerCode: 'Bitte Sticker-Code eingeben',
    codeFormatTips: 'Das Format STICKER_XXX wird empfohlen',
    codeExists: 'Dieser Sticker-Code existiert bereits, bitte ändern',
    codeValidateFailed: 'Validierung fehlgeschlagen',
    codeValidateError: 'Code-Validierung fehlgeschlagen, bitte erneut versuchen',
    codeFormatError: 'Ungültiges Code-Format, das Format STICKER_XXX wird empfohlen',
    codeCheckFailedRetry: 'Validierung fehlgeschlagen, bitte erneut versuchen',
    tagsPlaceholder: 'Mehrere Tags durch Kommas trennen, z.B.: glücklich, Emoji, Lächeln',
    tagsDesc: 'Für Suche und Kategorisierung',
    descPlaceholder: 'Bitte Sticker-Beschreibung eingeben',
    uploadImage: 'Bild hochladen',
    uploadThumbnail: 'Thumbnail hochladen',
    reuseStickerImage: 'Stickerbild wiederverwenden',
    reuseStickerImageTip: 'Das Thumbnail verwendet direkt das Stickerbild, kein separater Upload nötig',
    thumbnailOptional: 'Optional, kann vom System automatisch erstellt werden',
    thumbnailUploadSuccess: 'Thumbnail erfolgreich hochgeladen',
    selectCategoryAttr: 'Bitte eine Kategorie auswählen',
    completeFormInfo: 'Bitte alle Pflichtfelder im Formular ausfüllen',
    sortOrderPlaceholder: 'Je kleiner die Zahl, desto weiter oben',
    categoryCodePlaceholder: 'Bitte Kategorie-Code eingeben (Großbuchstaben)',
    categoryCodeDesc: 'Eindeutige Kennung, Großbuchstaben empfohlen, z.B.: HOT, CUTE',
    inputCategoryName: 'Bitte Kategorienamen eingeben',
    inputCategoryCode: 'Bitte Kategorie-Code eingeben',
    categoryCodePatternMsg: 'Bitte Großbuchstaben eingeben, Unterstriche erlaubt',
    categoryCodeExists: 'Dieser Kategorie-Code existiert bereits, bitte ändern',
    uploadCategoryIcon: 'Bitte Kategorie-Symbol hochladen',
    sortOrderMustNumber: 'Sortierreihenfolge muss eine Zahl sein',
    categoryDescPlaceholder: 'Bitte Kategoriebeschreibung eingeben',
    confirmDeleteCategory: 'Diese Kategorie wirklich löschen?',
    exportDeveloping: 'Exportfunktion wird entwickelt...',
    confirmDeleteGroup: 'Möchten Sie diese Gruppe wirklich löschen?',
    selectGroupToDelete: 'Bitte die zu löschende Gruppe auswählen',
    inputGroupName: 'Bitte Gruppennamen eingeben',
    groupNameTooLong: 'Gruppenname darf 50 Zeichen nicht überschreiten',
    inputGroupCode: 'Bitte Gruppen-Code eingeben',
    groupCodeFormatMsg: 'Gruppen-Code darf nur Großbuchstaben, Zahlen und Unterstriche enthalten',
    groupCodeTooLong: 'Gruppen-Code darf 50 Zeichen nicht überschreiten',
    groupCodeInvalidOrExists: 'Gruppen-Code ungültig oder bereits vorhanden, bitte prüfen',
    uploadGroupIcon: 'Bitte Gruppen-Symbol hochladen',
    sortOrderInvalid: 'Bitte gültige Sortierreihenfolge eingeben (Zahl >= 0)',
    selectStatusEnableDisable: 'Bitte Status auswählen (Aktiviert/Deaktiviert)',
    codeCheckErrorTips: '⚠️ Code-Validierung fehlgeschlagen, bitte später erneut versuchen',
    editFailed: 'Bearbeiten fehlgeschlagen',
    operationFailedRetry: 'Vorgang fehlgeschlagen, bitte erneut versuchen',
    apiException: 'Systemfehler',
    selectStickerType: 'Bitte Sticker-Typ auswählen'
  },
  filter: {
    filterName: 'Filtername',
    addFilter: '+ Filter hinzufügen',
    addFilterTitle: 'Filter hinzufügen',
    editFilterTitle: 'Filter bearbeiten',
    filterPreview: 'Filter-Vorschau',
    filterOriginalImage: 'Filter-Originalbild',
    filterResourceFile: 'Filter-Ressourcendatei',
    belongCompany: 'Händler',
    allMerchants: 'Alle Händler',
    type: 'Typ',
    builtIn: 'Integriert',
    nonBuiltIn: 'Nicht integriert',
    appliedMachines: 'Angewendete Geräte',
    defaultSort: 'Sortierung',
    serialNo: 'Nr.',
    batchCopy: 'Stapelkopie',
    copy: 'Kopieren',
    tip: 'Hinweis',
    deletePrompt: 'Beim Löschen dieses Filters können Geräte ihn nicht mehr verwenden. Möchten Sie ihn wirklich löschen?',
    editFilterSuccess: 'Filter erfolgreich bearbeitet',
    loadCompanyFailed: 'Händlerliste konnte nicht geladen werden',
    copyFilterSuccess: 'Filter erfolgreich kopiert',
    copyFilterFailed: 'Filterkopie fehlgeschlagen',
    batchCopySuccess: 'Filter erfolgreich kopiert',
    batchCopyFailed: 'Stapelkopie fehlgeschlagen',
    selectFilterFirst: 'Bitte wählen Sie zuerst die zu kopierenden Filter aus',
    copyToMerchantTitle: 'Filter auf Händler kopieren',
    batchCopyTitle: 'Filter stapelweise auf Händler kopieren',
    originalFilterName: 'Originalfiltername',
    newFilterName: 'Neuer Filtername',
    inputNewFilterName: 'Bitte geben Sie den neuen Filternamen ein',
    targetMerchant: 'Zielhändler',
    selectCompany: 'Bitte wählen Sie einen Händler',
    selectedFilters: 'Ausgewählte Filter',
    nameSuffix: 'Gemeinsamer Namenszusatz',
    inputNameSuffix: 'Bitte geben Sie den gemeinsamen Namenszusatz ein',
    nameSuffixTip: 'Neuer Filtername = Originalfiltername + dieser Zusatz',
    inputFilterName: 'Bitte geben Sie den Filternamen ein',
    inputName: 'Bitte geben Sie einen Namen ein',
    selectTypeMsg: 'Bitte wählen Sie einen Typ',
    inputDefaultSort: 'Bitte geben Sie die Sortierung ein',
    colorMatrix: 'Farbmatrix',
    whitening: 'Aufhellung',
    smoothing: 'Hautglättung',
    bigEye: 'Große Augen',
    thinFace: 'Schmales Gesicht',
    smallFace: 'Kleines Gesicht',
    forehead: 'Stirn',
    cheekbone: 'Wangen',
    nose: 'Nase',
    mouth: 'Mund',
    chin: 'Kinn',
    intensity: 'Filterintensität',
    sampleFullColor: 'Volllfarbe-Beispiel:',
    colorModeExample: 'Beispielbild im Farbmodus',
    pngFilterExample: 'PNG-Filter-Originalbeispiel',
    anyFormatMax10M: 'Beliebiges Format, max. 10 MB',
    colorModeNormal: 'Farbmodus – Normal:',
    colorModePressed: 'Farbmodus – Gedrückt:',
    reuseAllSampleColor: 'Volllfarbe-Beispiel für alle wiederverwenden',
    addUploadImage: 'Bild hochladen',
    uploadFile: 'Datei hochladen',
    reupload: 'Erneut hochladen',
    submit: 'Absenden',
    btnNormalRequired: 'Bild „Farbmodus – Normal“ darf nicht leer sein!',
    imageUrlRequired: 'Volllfarbe-Beispielbild darf nicht leer sein!',
    filterPngRequired: 'Filter-Originalbild darf nicht leer sein!',
    btnSelectedRequired: 'Bild „Farbmodus – Gedrückt“ darf nicht leer sein!',
    exceed10M: '10-MB-Limit überschritten, Hochladen nicht erlaubt~',
    uploadFailed: 'Hochladen fehlgeschlagen'
  },
  goods: {
    productName: 'Produktname',
    newProductName: 'Neuer Produktname',
    productCode: 'Produktcode',
    preview: 'Vorschau',
    width: 'Breite',
    height: 'Höhe',
    imageCount: 'Bildanzahl',
    frameTop: 'Abstand von oben',
    frameBottom: 'Abstand von unten',
    frameLeft: 'Abstand von links',
    frameRight: 'Abstand von rechts',
    frameCount: 'Rahmenanzahl',
    printMode: 'Druckmodus',
    orientation: 'Druckrichtung',
    price: 'Einzelpreis',
    companyPrice: 'Händlerpreis',
    increasePrice: 'Zusatzdruckpreis',
    defaultIncreasePrice: 'Standard-Zusatzdruckpreis',
    companyIncreasePrice: 'Händler-Zusatzdruckpreis',
    type: 'Typ',
    deviceCount: 'Angewendete Maschinen',
    operation: 'Operation',
    tip: 'Hinweis',
    confirmDelete: 'Nach dem Löschen können Maschinen dieses Produkt nicht mehr auswählen. Möchten Sie es wirklich löschen?',
    view: 'Anzeigen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    search: 'Suchen',
    addProduct: '+ Produkt hinzufügen',
    pleaseInputContent: 'Bitte geben Sie den Suchinhalt ein',
    sequenceNumber: 'Nr.',
    printingMode: 'Druckmodus',
    oneCopyInDuplicate: 'Eine Kopie',
    inDuplicate: 'Druckmodus',
    vertical: 'Vertikal',
    horizontal: 'Horizontal',
    riceConfirmation: 'Bitte geben Sie den korrekten Preis ein! Kann nur größer oder gleich 0.01 sein',
    cannotEditBuiltIn: 'Integrierte Produkte können nicht bearbeitet werden, nur der Superadmin kann sie bearbeiten',
    cannotDeleteBuiltIn: 'Integrierte Produkte können nicht gelöscht werden, nur der Superadmin kann sie löschen',
    copy: 'Kopieren',
    copyProduct: 'Produkt kopieren',
    originalProductName: 'Originaler Produktname',
    inputProductName: 'Bitte geben Sie den neuen Produktnamen ein',
    selectCompany: 'Bitte wählen Sie einen Händler',
    copySuccess: 'Produkt erfolgreich kopiert',
    frameManage: 'Rahmenverwaltung',
    orderNum: 'Sortierung',
    belongCategory: 'Kategorie',
    belongCompany: 'Händler',
    subCategory: 'Unterkategorie',
    groupName: 'Gruppenname'
  },
  order: {
    orderManagement: 'Bestellverwaltung',
    orderList: 'Bestellliste',
    all: 'Alle',
    paid: 'Bezahlt',
    completed: 'Abgeschlossen',
    unpaid: 'Unbezahlt',
    refunded: 'Erstattet',
    timeout: 'Zeitüberschreitung',
    canceled: 'Storniert',
    paying: 'Zahlung läuft',
    unclose: 'Nicht geschlossen',
    closed: 'Geschlossen',
    toBeReversed: 'Zu stornieren',
    reversed: 'Storniert',
    evaluated: 'Bewertet',
    exception: 'Ausnahme',
    unknown: 'Unbekannt',
    payFail: 'Zahlung fehlgeschlagen',
    notRefund: 'N/A',
    applyRefund: 'Rückerstattung beantragen',
    refundInProgress: 'Rückerstattung läuft',
    agreeRefund: 'Rückerstattung zustimmen',
    refuseRefund: 'Rückerstattung ablehnen',
    refundedStatus: 'Rückerstattung abgeschlossen',
    refundFail: 'Rückerstattung fehlgeschlagen',
    cancelRefund: 'Rückerstattung stornieren',
    photo: 'Foto',
    print: 'Drucken',
    remotePrint: 'FernDruck',
    viewRemotePhotos: 'Fotos anzeigen',
    remotePrintPhotos: 'FernDruck-Fotos',
    uploadPhotos: 'Hochgeladene Fotos',
    uploadPrint: 'Hochladen & Drucken',
    noPhotos: 'Keine Fotos',
    orderNumber: 'Bestellnummer',
    merchant: 'Entsprechender Händler',
    deviceNumber: 'Maschinennummer',
    payMode: 'Zahlungsweise',
    orderType: 'Bestelltyp',
    paymentStatus: 'Zahlungsstatus',
    totalPrice: 'Gesamtpreis',
    createTime: 'Erstellungszeit',
    payTime: 'Zahlungszeit',
    quantity: 'Menge',
    unitPrice: 'Einzelpreis',
    discountAmount: 'Rabattbetrag',
    refundStatus: 'Rückerstattungsstatus',
    refundReason: 'Bestellnotiz',
    operation: 'Operation',
    export: 'Exportieren',
    orderCount: 'Bestellanzahl',
    searchPlaceholder: 'Bitte geben Sie den Suchinhalt ein',
    agree: 'Rückerstattung zustimmen',
    refuse: 'Rückerstattung ablehnen',
    refund: 'Rückerstattung',
    viewPhoto: 'Fotos anzeigen',
    gifImage: 'Animiertes GIF',
    confirmAgreeRefund: 'Rückerstattungsantrag dieser Bestellung zustimmen?',
    agreeRefundContent: 'Nachdem Sie auf OK geklickt haben, wird diese Bestellung den Rückerstattungsantrag abschließen',
    agreeRefundSuccess: 'Rückerstattungsantrag erfolgreich zugestimmt',
    confirmRefuseRefund: 'Rückerstattungsantrag dieser Bestellung ablehnen?',
    refuseRefundContent: 'Nachdem Sie auf OK geklickt haben, wird diese Bestellung den Rückerstattungsantrag ablehnen',
    refuseRefundSuccess: 'Rückerstattungsantrag erfolgreich abgelehnt',
    deviceName: 'Maschinenname',
    viewPhotos: 'Foto-Details',
    photoDetail: 'Foto-Details',
    compositePhotos: 'Zusammengesetzte Fotos',
    originalPhotos: 'Originalfotos',
    noCompositePhotos: 'Keine zusammengesetzten Fotos',
    noOriginalPhotos: 'Keine Originalfotos',
    frameId: 'Rahmen-ID',
    copyOrderCode: 'Bestellcode kopieren',
    allMerchants: 'Alle Händler',
    allDevices: 'Alle Geräte',
    allPayModes: 'Alle Zahlungsarten',
    payWeixin: 'WeChat',
    payAlipay: 'Alipay',
    payShouqianba: 'Shouqianba',
    payDougong: 'Dougong',
    payYunguanjia: 'Cloud Manager',
    payLeyaoyao: 'Leyaoyao',
    payCoins: 'Münze',
    payFree: 'Gratis',
    payCoupon: 'Einlösungscode',
    payDai: 'Token',
    payCoin: 'Münzzahlung',
    payCash: 'Bargeld',
    payCard: 'Karte',
    copySuccess: 'Erfolgreich kopiert',
    copyFail: 'Kopieren fehlgeschlagen'
  },
  coupon: {
    all: 'Alle',
    notActivated: 'Nicht aktiviert',
    activated: 'Aktiviert',
    used: 'Verwendet',
    cancelled: 'Storniert',
    searchPlaceholder: 'Bitte geben Sie den Gutscheincode/Händlername/Gerätename ein',
    export: 'Exportieren',
    generateCoupon: 'Gutschein generieren',
    qrCode: 'QR-Code',
    noQrCode: 'Keiner',
    clickToPreview: 'Klicken Sie für Vorschau',
    couponQrCode: 'Gutschein-QR-Code',
    clickToDownload: 'Klicken Sie auf das Bild zum direkten Download',
    confirmCouponInfo: 'Bitte bestätigen Sie die Gutscheininformationen',
    merchantName: 'Händlername',
    selectMerchant: 'Bitte wählen Sie den Händlernamen',
    deviceObject: 'Geräteobjekt',
    selectDeviceFirst: 'Bitte wählen Sie zuerst das Gerät',
    couponQuantity: 'Gutscheinmenge',
    inputCouponQuantity: 'Bitte geben Sie die Gutscheinmenge ein',
    activateCoupon: 'Gutschein aktivieren?',
    yes: 'Ja',
    no: 'Nein',
    activate: 'Aktivieren',
    cancel: 'Stornieren',
    couponId: 'Gutscheinnummer',
    merchant: 'Händlername',
    deviceName: 'Gerätename',
    couponCode: 'Gutscheincode',
    status: 'Status',
    createTime: 'Generierungszeit',
    operation: 'Operation',
    activateSuccess: 'Erfolgreich aktiviert!',
    activateFailed: 'Aktivierung fehlgeschlagen!',
    cancelSuccess: 'Erfolgreich storniert!',
    cancelFailed: 'Stornierung fehlgeschlagen!',
    generateSuccess: 'Erfolgreich generiert!',
    generateFailed: 'Generierung fehlgeschlagen!',
    generating: 'Gutscheine werden generiert, bitte warten...',
    maxCouponLimit: 'Es können nicht mehr als 500 Gutscheine gleichzeitig generiert werden!',
    generateTip: 'Pro Vorgang können maximal 500 Gutscheine generiert werden. Für mehr bitte in mehreren Schritten generieren. Pro Maschine können monatlich maximal 2000 Gutscheine generiert werden.',
    selectMerchantFirst: 'Bitte wählen Sie zuerst einen Händler!',
    downloadSuccess: 'Erfolgreich heruntergeladen!'
  },
  dashboard: {
    date: 'Datum',
    flow: 'Kundenanzahl',
    companyCount: 'Neue Händleranzahl',
    deviceCount: 'Neue Maschinenanzahl',
    photoCount: 'Foto-Bestellanzahl',
    printCount: 'Druck-Bestellanzahl',
    amount: 'Gesamte Plattform-Einnahmen',
    justSumAmount: 'Plattform-Provision',
    companySumAmount: 'Händler-Provision',
    lineCount: 'Online-Maschinenanzahl',
    companyName: 'Händlername',
    deviceCode: 'Maschinencode',
    activeCode: 'Maschinencode',
    deviceName: 'Maschinenname',
    photo: 'Foto-Bestellanzahl',
    print: 'Druck-Bestellanzahl',
    totalPrice: 'Gesamte Plattform-Einnahmen',
    timeCycle: 'Zeit',
    defaultTimeFilter: 'Standard-Zeitfilter (Monat)',
    month: 'Monat',
    week: 'Woche',
    day: 'Tag',
    search: 'Suchen',
    export: 'Exportieren',
    refund: 'Rückerstattung',
    confirmRefund: 'Rückerstattung für diese Bestellung beantragen?',
    refundContent: 'Nachdem Sie auf OK geklickt haben, wird diese Bestellung einen Rückerstattungsantrag starten',
    refundSuccess: 'Bestell-Rückerstattungsantrag erfolgreich',
    confirmAgreeRefund: 'Rückerstattungsantrag dieser Bestellung zustimmen?',
    agreeRefundContent: 'Nachdem Sie auf OK geklickt haben, wird diese Bestellung den Rückerstattungsantrag abschließen',
    agreeRefundSuccess: 'Rückerstattungsantrag erfolgreich zugestimmt',
    confirmRefuseRefund: 'Rückerstattungsantrag dieser Bestellung ablehnen?',
    refuseRefundContent: 'Nachdem Sie auf OK geklickt haben, wird diese Bestellung den Rückerstattungsantrag ablehnen',
    refuseRefundSuccess: 'Rückerstattungsantrag erfolgreich abgelehnt',
    timeRangeRequired: 'Der Zeitraum darf nicht leer sein'
  },
  uiGroup: {
    uiGroupManage: 'UI-Gruppenverwaltung',
    newUIGroup: 'Neue UI-Gruppe',
    searchUIName: 'UI-Gruppennamen suchen...',
    resourceType: 'Ressourcentyp',
    adminDefine: 'Von Admin definiert',
    merchantDefine: 'Von Händler definiert',
    uiName: 'UI-Name',
    subPageCount: 'Unterseitenanzahl',
    downloadPackage: 'Paket herunterladen',
    onlyOneInCategoryCannotDelete: 'Nur eine UI-Gruppe in dieser Kategorie (Sprache + Produkt), Löschen nicht möglich',
    remark: 'Bemerkung',
    createTime: 'Erstellungszeit',
    pageManage: 'Seitenverwaltung',
    copy: 'Kopieren',
    copyPrompt: 'Sind Sie sicher, diese UI-Gruppe zu kopieren?',
    copySuccess: 'Erfolgreich kopiert',
    copyFail: 'Kopieren fehlgeschlagen',
    copyUIGroup: 'UI-Gruppe kopieren',
    originalUIName: 'Originaler UI-Gruppenname',
    newUIName: 'Neuer UI-Gruppenname',
    inputNewUIName: 'Bitte geben Sie den neuen UI-Gruppennamen ein',
    selectCompany: 'Bitte wählen Sie einen Händler',
    companyName: 'Händlername',
    addUIGroup: 'Neue UI-Gruppe',
    deletePrompt: 'Sind Sie sicher, diese UI-Gruppe zu löschen?',
    deleteSuccess: 'Erfolgreich gelöscht',
    editUIGroup: 'UI-Gruppe bearbeiten',
    editSuccess: 'Erfolgreich bearbeitet',
    addSuccess: 'UI-Gruppe erfolgreich hinzugefügt',
    addFail: 'UI-Gruppe hinzufügen fehlgeschlagen',
    newPage: 'Neue Seite',
    editPage: 'Seite bearbeiten',
    addPage: 'Seite hinzufügen',
    pageName: 'Seitenname',
    pageKey: 'Seitenschlüssel',
    pageOrder: 'Seitenreihenfolge',
    elementCount: 'Elementanzahl',
    elementManage: 'Elementverwaltung',
    pleaseInputPageName: 'Bitte geben Sie den Seitennamen ein',
    pleaseInputPageKey: 'Bitte geben Sie den Seitenschlüssel ein',
    pleaseInputPageOrder: 'Bitte geben Sie die Seitenreihenfolge ein',
    deletePagePrompt: 'Sind Sie sicher, diese Seite zu löschen? Nach dem Löschen nicht wiederherstellbar!',
    addPageSuccess: 'Seite erfolgreich hinzugefügt',
    addPageFail: 'Seite hinzufügen fehlgeschlagen',
    editPageSuccess: 'Seite erfolgreich bearbeitet',
    editPageFail: 'Seite bearbeiten fehlgeschlagen',
    deletePageSuccess: 'Seite erfolgreich gelöscht',
    deletePageFail: 'Seite löschen fehlgeschlagen',
    pageKeyExists: 'Der Seitenschlüssel existiert bereits, bitte ändern Sie ihn',
    productType: 'Produkttyp',
    elementName: 'Elementname',
    elementType: 'Elementtyp',
    allElement: 'Alle Elemente',
    editElement: 'Element bearbeiten',
    addElement: 'Element hinzufügen',
    elementValue: 'Elementwert',
    elementValueMsg: 'Bitte geben Sie den Elementwert ein',
    elementKey: 'Elementschlüssel',
    elementKeyMsg: 'Bitte geben Sie den Elementschlüssel ein',
    elementKeyPlaceholder: 'Der Elementschlüssel kann auf derselben Seite nicht dupliziert werden, es wird empfohlen, Buchstaben und Unterstriche zu verwenden',
    elementNameMsg: 'Bitte geben Sie den Elementnamen ein',
    elementTypeMsg: 'Bitte wählen Sie den Elementtyp',
    elementKeyError: 'Der Elementschlüssel existiert bereits auf der aktuellen Seite, bitte ändern Sie ihn',
    elemnetDeleteTips: 'Sind Sie sicher, dieses Element zu löschen?',
    batchEditElement: 'Elemente im Batch bearbeiten',
    horizontalLayout: 'Horizontales Layout',
    verticalLayout: 'Vertikales Layout',
    loadingElementList: 'Elementliste wird geladen...',
    allResourceType: 'Alle Ressourcentypen',
    pleaseInputUIName: 'Bitte geben Sie den UI-Gruppennamen ein',
    pleaseSelectResourceType: 'Bitte wählen Sie den Ressourcentyp',
    previewImage: 'Vorschaubild',
    reupload: 'Erneut hochladen',
    uploadPreviewImage: 'Vorschaubild hochladen',
    languageType: 'Sprache',
    selectLanguageType: 'Bitte Sprache auswählen',
    pageSize: 'Seitengröße',
    pixelWH: 'Pixel (B×H)',
    belongCompany: 'Händler',
    cancelDefaultConfirm: 'Möchten Sie den Standardstatus dieser UI-Gruppe wirklich aufheben?',
    setDefaultConfirm: 'Möchten Sie diese UI-Gruppe wirklich als Standard festlegen?',
    operateSuccess: 'Vorgang erfolgreich!',
    operateFail: 'Vorgang fehlgeschlagen',
    onlyJpgPng: 'Es können nur JPG- und PNG-Bilder hochgeladen werden!',
    exceed4M: 'Die Bildgröße darf 4 MB nicht überschreiten!',
    uploadSuccess: 'Upload erfolgreich',
    uploadSuccessNoUrl: 'Upload erfolgreich, aber die Bild-URL konnte nicht abgerufen werden',
    inputImageUrlPlaceholder: 'Oder geben Sie direkt eine Bild-URL ein (http/https)',
    useImageUrl: 'Diese URL verwenden',
    invalidImageUrl: 'Bitte geben Sie eine gültige Bild-URL ein (beginnt mit http:// oder https://)',
    imageUrlApplied: 'Bild-URL übernommen',
    pasteTip: 'Tipp: Nach dem Kopieren eines Bildes oder Erstellen eines Screenshots Strg+V/Cmd+V drücken, um es einzufügen und hochzuladen',
    pasteUploadSuccess: 'Eingefügtes Bild erfolgreich hochgeladen',
    langZhCN: 'Vereinfachtes Chinesisch',
    langEn: 'Englisch',
    langFr: 'Französisch',
    langKo: 'Koreanisch',
    langZhTW: 'Traditionelles Chinesisch',
    langVi: 'Vietnamesisch',
    langAr: 'Arabisch',
    langBih: 'Bosnisch',
    langTh: 'Thai',
    langDe: 'Deutsch',
    langEs: 'Spanisch'
  },
  deviceSetup: {
    title: 'Gerätekonfiguration',
    basicInfo: 'Grundinformationen',
    machineModelSN: 'Maschinenmodell [SN]',
    inputMachineSN: 'Bitte geben Sie den Maschinen-SN-Code ein',
    machineName: 'Maschinenname',
    inputMachineName: 'Bitte geben Sie den Maschinennamen ein',
    machineCode: 'Maschinencode',
    inputMachineCode: 'Bitte geben Sie den Maschinencode ein',
    machineAddress: 'Maschinenadresse',
    inputMachineAddress: 'Bitte geben Sie die Maschinenadresse ein',
    activationCode: 'Aktivierungscode',
    h5Url: 'H5-Seiten-URL',
    parseUrl: 'URL analysieren',
    urlEditorTitle: 'H5-URL-Parameterverwaltung',
    urlBase: 'Basis-URL',
    urlParams: 'URL-Parameter',
    paramName: 'Parametername',
    paramValue: 'Parameterwert',
    addParam: 'Parameter hinzufügen',
    noParams: 'Keine Parameter. Klicken Sie auf "Parameter hinzufügen"',
    done: 'Fertig',
    pasteTip: 'Tipp: Nach dem Kopieren eines Bildes oder Erstellen eines Screenshots Strg+V drücken, um es einzufügen und hochzuladen',
    pasteUploadSuccess: 'Eingefügtes Bild erfolgreich hochgeladen',
    filterByCompany: 'Nach Händler filtern',
    customerServicePhone: 'Kundenservice-Telefon',
    photoAccessType: 'Foto-Zugriffsmethode',
    selectPhotoAccessType: 'Bitte wählen Sie den Typ',
    paymentMode: 'Zahlungsmodus',
    selectPaymentMode: 'Bitte wählen Sie den Typ',
    onlinePayment: 'Online-Zahlung',
    offlineCoin: 'Physische Münze',
    scanQRCode: 'QR-Code scannen',
    addFriend: 'Freund hinzufügen',
    machineSettings: 'Maschineneinstellungen',
    uiGroupSelection: 'UI-Gruppenauswahl',
    selectUiGroup: 'Bitte wählen Sie die UI-Gruppe',
    uiSelection: 'UI-Auswahl',
    searchUiName: 'UI-Namen suchen',
    viewAll: 'Alle',
    viewSelected: 'Nur Ausgewählte',
    builtIn: 'Integriert',
    notBuiltIn: 'Nicht integriert',
    productSelection: 'Produktauswahl',
    searchProductName: 'Produktnamen suchen',
    selectAll: 'Alle auswählen',
    frameSelection: 'Rahmenauswahl',
    selectProductFirst: 'Bitte wählen Sie zuerst ein Produkt',
    searchFrameName: 'Rahmennamen suchen',
    noProductSelected: 'Bitte wählen Sie zuerst mindestens ein Produkt, dann wählen Sie ein Produkt, um die entsprechenden Rahmen anzuzeigen',
    noFrameData: 'Keine Rahmendaten für das aktuelle Produkt',
    filterSelection: 'Filterauswahl',
    searchFilterName: 'Filternamen suchen',
    stickerGroup: 'Sticker-Gruppe',
    searchGroupName: 'Gruppennamen suchen',
    noStickerGroupData: 'Keine Sticker-Gruppendaten',
    stickersCount: '{count} Sticker',
    parameterSettings: 'Parameter-Einstellungen',
    photoTime: 'Fotozeit',
    seconds: 'Sekunden',
    inputPhotoTime: 'Bitte geben Sie die Fotozeit ein',
    intervalTime: 'Intervallzeit',
    inputIntervalTime: 'Bitte geben Sie die Intervallzeit ein',
    paperCount: 'Papieranzahl',
    sheets: 'Blätter',
    inputPaperCount: 'Bitte geben Sie die Papieranzahl ein',
    paperCountRequired: 'Papieranzahl ist erforderlich',
    cancel: 'Abbrechen',
    save: 'Speichern',
    selectAtLeastOneProduct: 'Bitte wählen Sie mindestens ein Produkt',
    selectAtLeastOneFilter: 'Bitte wählen Sie mindestens einen Filter',
    paperCountMinLimit: 'Die Papieranzahl darf nicht unter 50 liegen',
    serverConnectionError: 'Serververbindungsfehler, bitte versuchen Sie es später erneut!',
    deviceThumbnail: 'Geräte-Miniaturansicht',
    modify: 'Ändern',
    upload: 'Hochladen',
    remoteDesktopInfo: 'Remote-Desktop-Info',
    remoteDesktopPlaceholder: 'Bitte geben Sie Remote-Desktop-Info ein (Ferncode)',
    format: 'Formatieren',
    belongCategory: 'Kategorie',
    selectBelongCategory: 'Bitte wählen Sie eine Kategorie',
    onlyJpgPng: 'Nur JPG- und PNG-Bilder können hochgeladen werden~',
    exceed4M: 'Überschreitet das 4M-Limit, Hochladen nicht erlaubt~',
    thumbnailUploadFailed: 'Hochladen der Miniaturansicht fehlgeschlagen',
    jsonFormatErrorFormat: 'Ungültiges JSON-Format, Formatierung nicht möglich, bitte prüfen und erneut versuchen',
    jsonFormatError: 'Ungültiges JSON-Format, bitte prüfen und erneut versuchen',
    showName: 'Geräte-Anzeigename (QR-Code scannen, um den Titel der E-Foto-Seite herunterzuladen)',
    showNamePlaceholder: 'Wird als Titel auf der Seite zum Herunterladen elektronischer Fotos angezeigt'
  },
  personal: {
    oldPassword: 'Altes Passwort',
    inputOldPassword: 'Bitte altes Passwort eingeben',
    strength: 'Stärke: ',
    passwordTip: 'Bitte mindestens 6 Zeichen eingeben. Verwenden Sie kein leicht erratbares Passwort.',
    newPassword: 'Neues Passwort',
    passwordPlaceholder: 'Mindestens 6 Zeichen, Groß-/Kleinschreibung beachten',
    confirmPassword: 'Erneut bestätigen',
    confirmPasswordPlaceholder: 'Passwort bestätigen',
    levelLow: 'Schwach',
    levelMedium: 'Mittel',
    levelStrong: 'Stark',
    minSixChars: 'Bitte ein Passwort mit mindestens 6 Zeichen eingeben',
    strengthNotEnough: 'Passwortstärke nicht ausreichend',
    inputPassword: 'Bitte Passwort eingeben',
    passwordNotMatch: 'Die beiden Passwörter stimmen nicht überein',
    oldPasswordIncorrect: 'Altes Passwort ist falsch',
    editProfile: 'Profil bearbeiten',
    updateAvatar: 'Avatar ändern',
    avatarAlt: 'Avatar',
    avatarUpdateSuccess: 'Avatar erfolgreich geändert',
    email: 'E-Mail',
    mobile: 'Mobil',
    dept: 'Abteilung',
    gender: 'Geschlecht',
    description: 'Beschreibung',
    inputEmail: 'Bitte E-Mail eingeben',
    inputMobile: 'Bitte Mobilnummer eingeben',
    emailInvalid: 'Bitte eine gültige E-Mail eingeben',
    emailMax: 'Länge darf 50 Zeichen nicht überschreiten',
    mobileInvalid: 'Bitte eine gültige Mobilnummer eingeben',
    selectGender: 'Bitte Geschlecht wählen',
    descMax: 'Länge darf 100 Zeichen nicht überschreiten',
    submit: 'Absenden',
    selectAvatar: 'Avatar auswählen',
    clickToSelect: 'Zum Auswählen klicken',
    updatingWarning: 'Avatar wird geändert, bitte nicht mehrfach klicken',
    updateAvatarFailed: 'Avatar konnte nicht aktualisiert werden',
    tabHthz: 'Houtian Huazi',
    tabAl: 'Ali-Serie',
    tabLm: 'LianMeng'
  },
  userInfo: {
    title: 'Benutzerinfo',
    account: 'Konto: ',
    role: 'Rolle: ',
    noRole: 'Keine Rolle',
    male: 'Männlich',
    female: 'Weiblich',
    confidential: 'Geheim',
    department: 'Abteilung: ',
    noDepartment: 'Keine Abteilung',
    gender: 'Geschlecht: ',
    phone: 'Telefon: ',
    noPhone: 'Telefon nicht verknüpft',
    email: 'E-Mail: ',
    noEmail: 'E-Mail nicht verknüpft',
    status: 'Status: ',
    locked: 'Gesperrt',
    valid: 'Aktiv',
    createTime: 'Erstellt: ',
    lastLogin: 'Letzte Anmeldung: ',
    description: 'Beschreibung: '
  },
  remotePrint: {
    loading: 'Wird geladen...',
    expired: 'Aufzeichnung abgelaufen',
    expiredDesc: 'Diese Upload-Aufzeichnung ist abgelaufen. Bitte kehren Sie zum Terminal zurück.',
    completed: 'Abgeschlossen',
    completedDesc: 'Fotos wurden erfolgreich übermittelt. Bitte warten Sie am Terminal auf den Druck.',
    submitted: 'Erfolgreich gesendet',
    submittedDesc: 'Fotos wurden an das Terminal gesendet. Bitte schließen Sie die weiteren Schritte am Gerät ab.',
    orderInfo: 'Bestellinfo',
    recordCode: 'Aufzeichnungs-Nr.',
    orderCode: 'Bestell-Nr.',
    product: 'Produkt',
    price: 'Preis',
    expireTime: 'Läuft ab um',
    photos: 'Fotos',
    addPhoto: 'Foto hinzufügen',
    tipFormat: 'Nur JPG/PNG-Format unterstützt',
    tipSize: 'Jedes Foto maximal 3MB',
    tipExpire: 'Aufzeichnung ist 5 Minuten gültig, bitte schnell hochladen',
    submit: 'Hochladen & Drucken',
    submitting: 'Wird gesendet...',
    noRecordCode: 'Aufzeichnungscode fehlt. Bitte QR-Code scannen.',
    loadFailed: 'Laden fehlgeschlagen. Bitte erneut versuchen.',
    invalidFormat: 'Nur JPG/PNG unterstützt',
    photoLimit: 'Maximal {count} Fotos hochladbar',
    fileTooLarge: 'Dateigröße darf 10MB nicht überschreiten',
    uploadFailed: 'Upload fehlgeschlagen. Bitte erneut versuchen.',
    noPhotoUploaded: 'Bitte laden Sie mindestens ein Foto hoch',
    submitFailed: 'Übermittlung fehlgeschlagen. Bitte erneut versuchen.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/de-DE.js